// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".required[data-v-1a71ee07]:after{content:\" *\";color:red}[data-v-1a71ee07] .p-picklist-source-controls,[data-v-1a71ee07] .p-picklist-target-controls{display:none}", ""]);
// Exports
module.exports = exports;
